module Meevo.Plugins.Register {
    "use strict";

    export class ChangeOptionsSection extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        public paymentCategoriesForCredit: RegisterPaymentCat[];

        constructor(
            registerContext: Meevo.Plugins.Register.RegisterContext,
            private modalService: Meevo.Components.Modal.IModalService
        ) {
            super(RegisterSectionTypeEnum.ChangeOptions, registerContext, "changeOptions", Register.RegisterSectionCatTypeEnum.Payment);
        }

        reset() {
            this.registerContext.setChangeDueAsCash = false;
            this.registerContext.isCreditMode = false;
            this.registerContext.getPaymentCategoriesForCredit().then((paymentCatgs) => {
                this.paymentCategoriesForCredit = paymentCatgs;
            });
        }

        selectCreditMethod(paymentCategory: RegisterPaymentCat) {
            if (paymentCategory.isDisabled) {
                this.modalService.alert(paymentCategory.disabledMessage);
                return;
            }

            if (this.registerContext.selectedMerchantAccount &&
                this.registerContext.selectedMerchantAccount.restrictUnlinkedCreditCardRefunds &&
                (paymentCategory.sectionType === RegisterSectionTypeEnum.CardOnFile  || 
                    (paymentCategory.sectionType === RegisterSectionTypeEnum.CreditMultiCard &&
                    this.registerContext.paymentRequestsBasedOnRefundItems.length < 1))) {

                    this.modalService.alert('MESSAGE_UNLINKED_CREDITCARD_REFUND_NOT_ALLOWED');
                    return;
                }

            this.registerContext.updatePoleDisplayCashRounding(paymentCategory.sectionType, false);

            if (this.registerContext.getCashChangeDue() != 0) {
                this.registerContext.isCreditMode = true;             
                this.registerContext.selectSection(paymentCategory.sectionType, true).then(() => {                  
                    if (paymentCategory.sectionType != RegisterSectionTypeEnum.Cash) {
                        const selectedSection = this.registerContext.selectedSection as RegisterPaymentSectionBase;
                        if (selectedSection && selectedSection.addBalanceAsPayment) {
                            selectedSection.addBalanceAsPayment();
                        }
                    }

                    if (this.registerContext.selectedSection instanceof CreditPaymentsSection) {
                        this.registerContext.selectedSection.setCardPaymentList(this.registerContext.paymentRequestsBasedOnRefundItems);
                    }
                });
            }
        }

        isPaymentTypeAllowedForRefund(paymentCategory: RegisterPaymentCat) {
            if (paymentCategory.sectionType == RegisterSectionTypeEnum.ClientPoints && !this.registerContext.hasRealClient()) {
                return false;
            }

            let isRefundable = true;
            if (paymentCategory.paymentCategory === Model.PaymentCategoryEnum.CreditDebit) {
                //we can only hide CCs based on setting when we control it, in case of CC Processor we don't
                if (!this.registerContext.creditCardProcessingEnabled) {
                    isRefundable = _(this.registerContext.paymentTypes).any((paymentType) => paymentType.paymentCategory === Model.PaymentCategoryEnum.CreditDebit && paymentType.isRefundable === true);
                }
            }
            else {
                //Payment not configured in DB won't have isRefundable, so we need to display it
                isRefundable = (paymentCategory.isRefundable != undefined ? paymentCategory.isRefundable : true);
            }

            if (this.registerContext.isMeevoPayProvider() && this.registerContext.hasExternalTipRefundDue()) {
                return paymentCategory.sectionType === RegisterSectionTypeEnum.CreditMultiCard;
            }

            return isRefundable;
        }
    }
}